import React from 'react';
import { 
  HiOutlineQueueList, 
  HiOutlineBell, 
  HiOutlineArrowsRightLeft 
} from 'react-icons/hi2';
import styles from './Enquiries.module.css';

const EnquiriesSummaryCards = ({ summaryData }) => {
  const cards = [
    {
      label: 'Total Enquiries',
      value: summaryData.total,
      icon: <HiOutlineQueueList />,
      iconClass: styles.summaryCardIconBlue
    },
    {
      label: 'New Enquiries',
      value: summaryData.new,
      icon: <HiOutlineBell />,
      iconClass: styles.summaryCardIconGreen
    },
    {
      label: 'In Conversation',
      value: summaryData.inConversation,
      icon: <HiOutlineArrowsRightLeft />,
      iconClass: styles.summaryCardIconAmber
    }
  ];

  return (
    <div className={styles.summaryCards}>
      {cards.map((card, index) => (
        <div key={index} className={styles.summaryCard}>
          <div className={styles.summaryCardContent}>
            <div className={`${styles.summaryCardIcon} ${card.iconClass}`}>
              {card.icon}
            </div>
            <div className={styles.summaryCardText}>
              <p className={styles.summaryCardLabel}>{card.label}</p>
              <p className={styles.summaryCardValue}>{card.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EnquiriesSummaryCards;